import react from 'react'; // eslint-disable-line
import { graphql, useStaticQuery } from 'gatsby';
import { StrapiPage } from '../gatsby/types/strapi-page';

export type AllPages = {
  allStrapiTranslationPage: {
    edges: {
      node: StrapiPage;
    }[]
  }
}

export const useStrapiPagesTranslations = (
): StrapiPage[] => {
  const { allStrapiTranslationPage } = useStaticQuery<AllPages>(graphql`
    query {
      allStrapiTranslationPage(filter: {
        pageSettings: {publishStatus: {eq: true}},
        seoSettings: {metaIndex: {eq: "index"}},
      }) {
        edges {
          node {
            id
            title
            pageSettings {
              id
              slug
              subpath
              language
              publishStatus
              parentPagePath
              parentPageTitle
            }
            additionalPageSettings {
              sitemapGroup
            }
          }
        }
      }
    }
  `);

  return allStrapiTranslationPage.edges.map(({ node }) => node);
};

export default useStrapiPagesTranslations;
